import React from 'react';

import { Skeleton, Stack } from './index.styles';

const SkeletonStack = () => (
  <Stack spacing={2}>
    <span>
      <Skeleton variant="rectangular" height={32} />
      <Skeleton variant="rectangular" height={128} />
    </span>
    <span>
      <Skeleton variant="rectangular" height={32} />
      <Skeleton variant="rectangular" height={128} />
    </span>
  </Stack>
);

export default SkeletonStack;
